import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CircularLoader from 'app/design/uiComponents/CircularLoader';
import BotDetailPageHeader from 'app/components/Bots/BotDetail/BotDetailPageHeader';
import BotStatusAction from 'app/components/Bots/BotDetail/BotStatusAction';
import BotDetailLinks from 'app/components/Bots/BotDetail/BotDetailLinks';
import BotStopAction from 'app/components/Bots/BotDetail/BotStopAction';
// import BotDetailAttributes from 'app/components/Bots/BotDetail/BotDetailAttributes';
import BotDetailDescription from 'app/components/Bots/BotDetail/BotDetailDescription';
import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';

// Service
import useGetBotDetails from 'services/Bots/useGetBotDetails';
import BotArchiveAction from 'app/components/Bots/BotDetail/BotArchiveAction';
import { UserBot } from 'app/components/Bots/StrategyBuilder/types';
import useEditUserStrategy from 'services/Bots/useEditUserStrategy';

export function BotDetailsPage({ location }: { location: { search: string } }) {
  const { bid, sid, title } =
    useParams<{ bid: string; sid: string; title: string }>();
  const subId = isNaN(parseInt(sid)) ? 0 : parseInt(sid);
  const { data, isLoading } = useGetBotDetails(parseInt(bid), subId);
  const mutationEdit = useEditUserStrategy(
    data && data.user_botid ? Number(data.user_botid) : 0,
    () => {
      //
    },
  );

  const [isFavorite, setIsFavorite] = useState(
    data && data.is_favourite ? data.is_favourite : false,
  );
  const handleFavoriteClick = () => {
    setIsFavorite(prev => !prev);
    mutationEdit.mutate({ is_favourite: !isFavorite });
};

  return (
    <>
      <Helmet>
        <title>Bots Detail</title>
        <meta name="description" content="Bots Detail Page" />
      </Helmet>

      <CircularLoader open={isLoading} />
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <BotDetailPageHeader />
        <Tooltip
          title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
        >
          <IconButton
            onClick={handleFavoriteClick}
            color={isFavorite ? 'warning' : 'default'}
            sx={{ m: 4, mb: 0, p: 1.5 }}
          >
            {isFavorite ? (
              <StarIcon sx={{ fontSize: 36, color: '#FFD700' }} />
            ) : (
              <StarBorderIcon sx={{ fontSize: 36 }} />
            )}
          </IconButton>
        </Tooltip>
      </Box>
      <BotDetailDescription />
      {/* <BotDetailAttributes /> */}
      <BotStatusAction search={location.search} />
      <BotDetailLinks />
      <Box
        className="m-main-spacing"
        display="flex"
        justifyContent="right"
        gap={2}
        flexWrap={'wrap'}
      >
        <BotArchiveAction />
        <BotStopAction
          search={location.search}
          bid={bid}
          sid={sid}
          isRestart={true}
        />
      </Box>

      {/* {data && data.name && (
        <Box sx={{ pt: 3 }} className="p-main-spacing">
          <Divider />
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ my: 3 }}
          >
            <Typography variant="body2" sx={{ mb: 2 }} fontWeight={500}>
              Share on
            </Typography>
            <ShareIcons variant="small" title={data.name} />
          </Box>
        </Box>
      )} */}
    </>
  );
}
